import { render, staticRenderFns } from "./GeneralInfoFormSkeleton.vue?vue&type=template&id=9c53a5d0&"
import script from "./GeneralInfoFormSkeleton.vue?vue&type=script&lang=js&"
export * from "./GeneralInfoFormSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./GeneralInfoFormSkeleton.vue?vue&type=style&index=0&id=9c53a5d0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports